<mat-horizontal-stepper [linear]="true">
  <mat-step [stepControl]="firstFormGroup">
    <form [formGroup]="firstFormGroup">
      <ng-template matStepLabel>
        <div>
          <span active>Name</span>
        </div>
      </ng-template>
      <table class="attribute-full-width">
        <tr class="offset-x">
          <td>
            <mat-form-field>
              <input [attr.data-testid]="'name_text'" formControlName="name" matInput
                placeholder="PIN Override Group Name" required="true" />
              @if (
                firstFormGroup.controls['name'].invalid &&
                !firstFormGroup.controls['name'].value
                ) {
                <mat-error>Please enter a Name
                </mat-error>
              }
            </mat-form-field>
          </td>
          <td>
            <mat-form-field>
              <input [attr.data-testid]="'description_text'" formControlName="description" matInput
                placeholder="Description" required="false" />
            </mat-form-field>
          </td>
        </tr>
      </table>
      <div  class="container flex-center-center">
        <button [attr.data-testid]="'cancel_button'" class="button-color button-margin" mat-raised-button
          type="button" (click)="onNoClick()">
          Cancel
        </button>
        <button [attr.data-testid]="'submit_button'" mat-raised-button matStepperNext type="button"
          class="button-color">
          Next
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="secondFormGroup">
    <form [formGroup]="secondFormGroup">
      <ng-template matStepLabel>
        <div>
          <span active>Dates</span>
        </div>
      </ng-template>
      <table class="attribute-full-width">
        <tr class="offset-x">
          <td>
            <emm-effective-date-selection source="management" [label]="'Effective Date'" [minDate]="minDate"
              (effectiveDateChange)="selectEffectiveDate($event)">
            </emm-effective-date-selection>
          </td>
        </tr>
        <tr class="offset-x">
          <td>
            <emm-effective-date-selection source="management" [label]="'End Date'" [minDate]="minDate"
              [disabled]="noEndDate" (effectiveDateChange)="selectEndDate($event)">
            </emm-effective-date-selection>
            <span class="ml-4">
              <mat-slide-toggle formControlName="noEndDate" (change)="selectNoEndDate($event)">No end date
              </mat-slide-toggle>
            </span>
            @if (secondFormGroup.invalid) {
              <mat-error class="small">
                Please enter required dates
              </mat-error>
            }
          </td>
        </tr>
      </table>
      <div  class="container flex-center-center">
        <button [attr.data-testid]="'cancel_button'" class="button-color button-margin" mat-raised-button
          type="button" (click)="onNoClick()">
          Cancel
        </button>
        <button [attr.data-testid]="'submit_button'" mat-raised-button matStepperPrevious type="button"
          class="button-color button-margin">
          Back
        </button>
        <button [attr.data-testid]="'submit_button'" mat-raised-button matStepperNext type="button"
          class="button-color">
          Next
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="thirdFormGroup">
    <form [formGroup]="thirdFormGroup">
      <ng-template matStepLabel>
        <div>
          <span active>Location</span>
        </div>
      </ng-template>
      <table class="attribute-full-width">
        <tr class="offset-x">
          <td>
            <!-- Location Set type dropdown -->
            <emm-location-set-type-picker
              [locationSetTypes]="this.data.locationSetTypes$ | async"
              (locationSetTypeSelected)="locationSetTypeSelected($event)">
            </emm-location-set-type-picker>

            <!-- Location set dropdown -->
            @if (selectedLocationSetType$ | async; as selectedLocationSetType) {
              <emm-location-set-picker
                [isLocationSetTypeParent]="isLocationSetTypeParent$ | async"
                [locationSets]="childLocationSets$ | async" [parentLabel]="parentLabel$ | async"
                [parentLocationSets]="parentLocationSets$ | async"
                [selectedLocationSetType]="selectedLocationSetType"
                (locationSetFilter)="filterLocationSets($event)"
                (locationSetSelected)="locationSetSelected($event)"
                (parentLocationSetSelected)=" parentLocationSetSelected($event)"
                (resetSelected)="resetSelectedLocationSet()">
              </emm-location-set-picker>
            }
          </td>
        </tr>
      </table>
      <div  class="container flex-center-center">
        <button [attr.data-testid]="'cancel_button'" class="button-color button-margin" mat-raised-button
          type="button" (click)="onNoClick()">
          Cancel
        </button>
        <button [attr.data-testid]="'submit_button'" mat-raised-button matStepperPrevious type="button"
          class="button-color button-margin">
          Back
        </button>
        <button [attr.data-testid]="'submit_button'" mat-raised-button matStepperNext type="button"
          class="button-color">
          Next
        </button>
      </div>
    </form>
  </mat-step>

  <mat-step [stepControl]="fourthFormGroup">
    <form [formGroup]="fourthFormGroup" (ngSubmit)="onSubmit()">
      <ng-template matStepLabel>
        <div>
          <span active>Overrides</span>
        </div>
      </ng-template>
      <p id="hint">Enter overrides below by clicking the + button or
        <a id="open-file-upload" (click)="handleFileUpload()"><strong>click here</strong> to upload a file</a>
      </p>
      <div class="table-container">
        <table id="add-pin-overrides-table">
          <thead>
            <tr id="table-headers" [style.visibility]="areHeadersVisible ? 'visible' : 'hidden'">
              <th><label>RMI</label></th>
              <th><label>Primary Override</label></th>
              <th><label>Secondary Override</label></th>
              <th><label>Whole Product Override</label></th>
              <th><label>Sampling Distribution Override</label></th>
            </tr>
          </thead>
          <tbody>
            @for (field of fields; track field) {
              <tr [style.visibility]="!fileUploaded ? 'visible' : 'hidden'">
                <td>
                  <input
                    class="form-control"type="number" [(ngModel)]="field.rmi"
                    [ngModelOptions]="{standalone: true}" name="{{ field.rmi }}"/>
                </td>
                <td>
                  <input class="form-control" type="number" [(ngModel)]="field.primaryOverride"
                    [ngModelOptions]="{standalone: true}" name="{{ field.primaryOverride }}" />
                </td>
                <td>
                  <input class="form-control" type="number" [(ngModel)]="field.secondaryOverride"
                    [ngModelOptions]="{standalone: true}" name="{{ field.secondaryOverride }}" />
                </td>
                <td>
                  <input class="form-control" type="number" [(ngModel)]="field.wholeProductOverride"
                    [ngModelOptions]="{standalone: true}" name="{{ field.wholeProductOverride }}" />
                </td>
                <td>
                  <input class="form-control" type="number" [(ngModel)]="field.samplingDistributionOverride"
                    [ngModelOptions]="{standalone: true}"
                    name="{{ field.samplingDistributionOverride }}" />
                </td>
                <td>
                  <button class="btn btn-default" type="button" (click)="deleteRow()">Delete</button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="table-container">
        <table id="add-pins-by-file-table">
          <thead>
            <tr id="file-table-headers" [style.visibility]="areFileTableHeadersVisible ? 'visible' : 'hidden'">
              <th><label>RMI</label></th>
              <th><label>Primary Override</label></th>
              <th><label>Secondary Override</label></th>
              <th><label>Whole Product Override</label></th>
              <th><label>Sampling Distribution Override</label></th>
            </tr>
          </thead>
          <tbody>
            @for (pinOverride of this.fileArray; track pinOverride) {
              <tr matRow
                [style.visibility]="fileUploaded ? 'visible' : 'hidden'">
                <td>
                  <input class="form-control" type="number" [(ngModel)]="pinOverride.rmi" [ngModelOptions]="{standalone: true}"
                    name="{{ pinOverride.rmi }}" value="{{ pinOverride.rmi }}" />
                </td>
                <td>
                  <input class="form-control" type="number" [(ngModel)]="pinOverride.primaryOverride" [ngModelOptions]="{standalone: true}"
                    name="{{ pinOverride.primaryOverride }}" value="{{ pinOverride.primaryOverride }}" />
                </td>
                <td>
                  <input class="form-control" type="number" [(ngModel)]="pinOverride.secondaryOverride" [ngModelOptions]="{standalone: true}"
                    name="{{ pinOverride.secondaryOverride }}" value="{{ pinOverride.secondaryOverride }}" />
                </td>
                <td>
                  <input class="form-control" type="number" [(ngModel)]="pinOverride.wholeProductOverride" [ngModelOptions]="{standalone: true}"
                    name="{{ pinOverride.wholeProductOverride }}" value="{{ pinOverride.wholeProductOverride }}" />
                </td>
                <td>
                  <input class="form-control" type="number" [(ngModel)]="pinOverride.samplingDistributionOverride" [ngModelOptions]="{standalone: true}"
                    name="{{ pinOverride.samplingDistributionOverride }}" value="{{ pinOverride.samplingDistributionOverride }}" />
                </td>
                <td>
                  <button mat-button matTooltip="Delete Row" type="button" (click)="deleteFileRow()">Delete</button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
      <div  class="container flex-center-center">
        <button [attr.data-testid]="'add_override_button'" class="button-color button-margin"
          id="add-override-button" mat-raised-button type="button" (click)="addRow()" NgControl>
          +
        </button>
        <button class="button-color button-margin" [attr.data-testid]="'cancel_button'"  mat-raised-button
          type="button" (click)="onNoClick()">
          Cancel
        </button>
        <button [attr.data-testid]="'submit_button'" mat-raised-button matStepperPrevious type="button"
          class="button-color button-margin">
          Back
        </button>
        <button [attr.data-testid]="'submit_button'" mat-raised-button matStepperNext type="submit"
          class="button-color">
          Save
        </button>
      </div>
    </form>
  </mat-step>
</mat-horizontal-stepper>
